export const RemoveSpecialCharacters = (input: string) => {
  return input.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
